import type { Action } from './actions'
import type { CommonStoreState } from './store'

const getUpdated = (anyProps: Record<string, any> | null | undefined, curProps: Record<string, any>): Record<string, any> | undefined => {
  if (!anyProps) {
    return
  }
  let changed = false
  const updated = Object.keys(anyProps).reduce((o, key) => {
    if (curProps[key] !== anyProps[key]) {
      o[key] = anyProps[key]
      changed = true
    }
    return o
  }, {} as any) as Partial<CommonStoreState>
  if (changed) {
    return updated
  }
}

const reducer = (state: CommonStoreState, action: Action): CommonStoreState => {
  switch (action.type) {
    case 'update-props': {
      const updated = getUpdated(action.props, state as Record<string, any>)
      if (updated) {
        return { ...state, ...updated }
      }
      return state
    }
    case 'update-activation-data': {
      return {
        ...state,
        activationData: {
          ...state.activationData,
          ...action.data,
        }
      }
    }
    case 'update-activation-instances': {
      return {
        ...state,
        activationData: {
          ...state?.activationData,
          instances: {
            ...state?.activationData?.instances,
            ...action?.instances
          },
        }
      }
    }
    default:
      throw new Error('unknown action')
  }
}

export default reducer
